import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import _ from 'lodash';

export const useGetDCList = (params) => {
    const isParams = !_.isEmpty(params);
    const searchparam = isParams ? `?searchparam=dc_name.${params}` : '';

    return useQuery({
        queryKey: ['list-dc', params],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/dc/list${searchparam}`);
            return data?.data?.page_data;
        },
        select: (res) => {
            const data = res?.map((r) => ({
                id: r.id,
                name: r.dc_name,
            }));

            return data;
        },
        enabled: !!searchparam,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};

export const useGetSalesArea = (params) => {
    const isParams = !_.isEmpty(params);
    const searchparam = isParams ? `?searchparam=name.${params}` : '';

    return useQuery({
        queryKey: ['list-sales-area', params],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/sales-area/list${searchparam}`);
            return data?.data?.page_data;
        },
        enabled: !!searchparam,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};

export const useGetParahubStoreName = (params) => {
    const isParams = !_.isEmpty(params);
    const searchparam = isParams ? `?searchparam=nama_outlet.${params}` : '';

    return useQuery({
        queryKey: ['list-parahub-store-name', params],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/audit-trail/parahub-store-name${searchparam}`);
            return data?.data?.page_data;
        },
        select: (res) => {
            const data = res?.map((r) => ({
                id: r.customer_id,
                name: r.nama_outlet,
            }));

            return data;
        },
        enabled: !!searchparam,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};
